export default __webpack_public_path__ + "static/media/zrak-barvy.37d25f54.svg";